import { useAPI } from "../Api";
import { useLibrary } from "../Library";
import { AttachFiles } from "./AttachFiles";
import { DeleteDialog } from "./DeleteDialog";
import React, { useState, useEffect } from 'react'
import { Checkbox, Pane, Text, Button, ComparisonIcon, TickCircleIcon, ArrowRightIcon, FolderOpenIcon, DownloadIcon, Tooltip, Spinner, toaster, PaperclipIcon } from 'evergreen-ui'


export function BookAttachments(props) {
    const API = useAPI();
    const Library = useLibrary();
    const [attachments, setAttachments] = React.useState([]);
    const [busy, setBusy] = React.useState(false);
    const [disabled, setDisabled] = React.useState(false);
    const dxfName = props.book.filename;

    let HandleFileUpload = (async (file, amtOfFiles) => {
        if ((attachments.length + amtOfFiles) > 3) {
            toaster.danger('Sorry, uploading these files will exceed the amount of allowed attachments');
            return;
        }
        const res = await Library.attachFile(file, file.name, dxfName);
        if (!res)
            return toaster.danger('There seems to be a problem with the upload, Please try again');
        loadAttachments();
    });

    const loadAttachments = () => {
        setBusy(true);
        API.jsonFetch('files/attach/' + dxfName).then((res) => {
            if (res) {
                if (res.data.length < 3) {
                    setDisabled(false);
                } else {
                    setDisabled(true);
                }
                setAttachments(res.data);
                setBusy(false);
            }
        })
    }

    const deleteFileAttachment = (filename) => {
        setBusy(true)
        API.jsonPost('files/attach/' + dxfName + '/' + filename, [], null, 'DELETE').then((res) => {
            if (res) {
                toaster.success(`Deleted ${filename}`)
                loadAttachments();
            } else {
                toaster.danger("Something went wrong with deleting the file, please try again");
            }
            setBusy(false)
        })

    }

    const downloadFileAttachment = (filename) => {
        API.authFetch('files/attach/' + dxfName + '/' + filename).then((res) => {
            if (res) {
                return res.blob().then(blob => {
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = filename;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(url);
                }).catch(error => {
                    console.error('There was a problem with the downloading the file:', error);
                });
            } else {
                toaster.danger("Something went wrong with the download, please try again")
            }
        })
    }

    useEffect(() => {
        loadAttachments()
    }, [])


    return <Pane marginTop={10}>

        {busy ? <Pane display="flex" justifyContent="center" alignItems="center"> <Spinner /> </Pane> : <><AttachFiles onChange={HandleFileUpload} maxFiles={disabled} />
            <Pane display="flex" justifyContent="center" alignItems="center" flexDirection="row" flexWrap="wrap">
                {attachments.length > 0 && attachments.map((a, i) => {
                    return <Pane flex={"1"} key={i} display={"flex"} justifyContent="center" alignItems={"center"} flexDirection={"row"} gap={"10px"} margin={10} padding={"20px"} width="80%" border={"1px solid lightgrey"} borderRadius={"10px"} height={"75px"}>

                        <PaperclipIcon color={"#206be1"} /> <Tooltip content={a}><Text overflow={"hidden"} width={"80%"}>{a}</Text></Tooltip>
                        <Tooltip content="Download File">
                            <DownloadIcon color={"#206be1"} cursor={"pointer"} onClick={() => { downloadFileAttachment(a); }} />
                        </Tooltip>
                        <DeleteDialog color={"red"} named={a} onDelete={() => { deleteFileAttachment(a); }} />
                    </Pane>;
                })}
            </Pane></>}
        <Pane display="flex" justifyContent="center" textAlign="center">
            <Text display="flex" justifyContent="center" textAlign="center" gap={"5px"} fontStyle={'italic'}><strong>Attach Files</strong>- You can attach a maximum of 3 files</Text>
        </Pane>
    </Pane>;
}